import { useEffect, useRef } from 'react';
import MessageSentIcon from '../../assets/icons/message-sent-icon.svg';

interface Props {
  setModalOn: (modalOn: boolean) => void;
  firstText: string;
  secondText: string;
}

export const MessageModal = (props: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        props.setModalOn(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        props.setModalOn(false);
      }
    };
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <div className='modal-active dark-100'>
      <div className='main-modal'>
        <div className='padding-bottom-5' ref={modalRef}>
          <div className='message-modal bg-gray-700'>
            <img className='message-modal__icon' src={MessageSentIcon} alt='Message sent' />
            <p className='font-h2-regular margin-top-3'>{props.firstText}</p>
            <p className='font-h4-regular'>{props.secondText}</p>
            <button className='button-secondary margin-top-2' onClick={() => props.setModalOn(false)} type='button'>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
